import { useForm } from "react-hook-form";
import InputsFields from "../../helpers/InputFields"
import { CategoryInputs } from "../../utils/listInputs/CategoryInputs";
import { useAddCategoryMutation, useUpdateCategoryMutation } from "../../store/services/CategoryService";
import Loader from "../main/Loader";
import { toast } from "react-toastify";
import { setIsOpenDialog } from "../../store/feautures/DialogSlice";
import { useDispatch } from "react-redux";

type IProps = {
    type: 'add' | 'update',
    idAzienda: number,
    dataInfo?: any,
}

export default function CategoryForm({ type, idAzienda, dataInfo }: IProps) {

    const form = useForm({ defaultValues: { nome: dataInfo?.nome } });
    const [addCategory, resultAdd] = useAddCategoryMutation();
    const [updateCategory, resultUpdate] = useUpdateCategoryMutation();
    const dispatch =useDispatch();
    const { handleSubmit } = form;

    const handleSubmitCatData = async (dataForm: any) => {

        let result: any;
        const resultLabel = type === 'update' ? 'modificata' : 'creata';

        if (type === 'update') {
            result = await updateCategory({ idAzienda: idAzienda, idCategoria: dataInfo.id, ...dataForm });
        } else {
            result = await addCategory({idAzienda: idAzienda, ...dataForm});
        }

        if ('error' in result) {
            toast.error(`Categoria non ${resultLabel}! Errore: ${result?.error?.data?.detail}`)
        } else {
            toast.success(`Categoria ${resultLabel}! `);
            dispatch(setIsOpenDialog(true));
        }
    }

    return (
        <div className="p-10 flex flex-col gap-y-8">
            {(resultAdd.isLoading || resultUpdate.isLoading) && <Loader />}
            <h5 className="text-[#064e3b] text-xl font-medium">
                {type === 'add' && 'Aggiungi '}
                {type === 'update' && 'Modifica '}
                categoria
            </h5>

            <form onSubmit={handleSubmit(handleSubmitCatData)}>
                <InputsFields arrFields={CategoryInputs} form={form} />

                <div className="flex justify-end my-6">
                    <button className="h-10 bg-[#064e3b] text-white px-5 w-64 rounded-lg text-md">Salva</button>
                </div>
            </form>
        </div>
    )
}